import mendeleev from "@/urls/mendeleev"
import {
  sendGetRequest,
} from "@/helper/requests"
// import {executeRequest} from "@/store/modules/utils";

const state = {
  partners: {
    currentUrl: null,
    items: [],
    loading: false,
    count: 0,
    detail: null,
    next: null,
    prev: null,
    error: null,
    lazyItems: [],
    lazyLoading: false,
    newPartnersItems: [],
    newPartnersLoading: false,
  }
}

const getters = {
  getPartners: state => state.partners.items,
  getLazyPartners: state => state.partners.lazyItems,
  getNewPartners: state => state.partners.newPartnersItems,
  getPartnersCount: state => state.partners.count,
  getPartnersCurrentUrl: state => state.partners.currentUrl,
  getPartnersNext: state => state.partners.next,
  getPartnersPrev: state => state.partners.prev,
  getPartnersDetail: state => state.partners.detail,
  isLoadingPartners: state => state.partners.loading,
  isLazyLoadingPartners: state => state.partners.lazyLoading,
  isLoadingNewPartners: state => state.partners.newPartnersLoading,
  savePartnersError: state => state.partners.error,
}

const actions = {
  loadPartners: ({ commit, getters }, { url, urlAppend, finalizer = () => {}, catcher = () => {} }) => {
    if (!url) {
      url = mendeleev.USER.PARTNERS.LIST()
      if (urlAppend) url = urlAppend(url)
    }
    if (!getters.isLoadingPartners) {
      commit('SET_PARTNERS_LOADING')
      sendGetRequest(
        url, (data, url) => {
          commit('SET_PARTNERS', data.results)
          commit('SET_PARTNERS_COUNT', data.count)
          commit('SET_PARTNERS_CURRENT_URL', url)
          commit('SET_PARTNERS_NEXT_URL', data.next)
          commit('SET_PARTNERS_LOADING_END')
          finalizer(data, url)
        }, (data, url) => {
          commit('SET_PARTNERS_LOADING_END')
          commit('SAVE_PARTNERS_ERROR', data)
          catcher(data, url)
        }
      )
    }
  },
  loadLazyPartners: ({ commit, getters }, { url, urlAppend, finalizer = () => {}, catcher = () => {} }) => {
    if (!url) {
      url = mendeleev.USER.PARTNERS.LAZY()
      if (urlAppend) url = urlAppend(url)
    }
    if (!getters.isLoadingPartners) {
      commit('SET_LAZYPARTNERS_LOADING')
      sendGetRequest(
        url, (data, url) => {
          commit('SET_LAZYPARTNERS', data)
          commit('SET_LAZYPARTNERS_LOADING_END')
          finalizer(data, url)
        }, (data, url) => {
          commit('SET_LAZYPARTNERS_LOADING_END')
          commit('SAVE_PARTNERS_ERROR', data)
          catcher(data, url)
        }
      )
    }
  },
  loadNewPartners: ({ commit, getters }, { url, urlAppend, finalizer = () => {}, catcher = () => {} }) => {
    if (!url) {
      url = mendeleev.USER.PARTNERS.NEW()
      if (urlAppend) url = urlAppend(url)
    }
    if (!getters.isLoadingNewPartners) {
      commit('SET_NEWPARTNERS_LOADING')
      sendGetRequest(
        url, (data, url) => {
          commit('SET_NEWPARTNERS', data)
          commit('SET_NEWPARTNERS_LOADING_END')
          finalizer(data, url)
        }, (data, url) => {
          commit('SET_NEWPARTNERS_LOADING_END')
          commit('SAVE_PARTNERS_ERROR', data)
          catcher(data, url)
        }
      )
    }
  },
  loadPartnersDetail: ({ commit }, { url, id, finalizer = () => {}, catcher = () => {} }) => {
    if (!url) url = url = mendeleev.USER.PARTNERS.DETAIL(id)
    sendGetRequest(
      url, (data, url) => {
        commit('SET_PARTNERS_DETAIL', data)
        finalizer(data, url)
      }, (data, url) => {
        commit('SAVE_PARTNERS_ERROR', data)
        catcher(data, url)
      }
    )
  },
}

const mutations = {
  SET_PARTNERS: (state, value) => {
    state.partners.items = value
  },
  SET_LAZYPARTNERS: (state, value) => {
    state.partners.lazyItems = value
  },
  SET_NEWPARTNERS: (state, value) => {
    state.partners.newPartnersItems = value
  },
  SET_PARTNERS_DETAIL: (state, value) => {
    state.partners.detail = value
  },
  SET_PARTNERS_COUNT: (state, value) => {
    state.partners.count = value
  },
  SET_PARTNERS_CURRENT_URL: (state, value) => {
    state.partners.currentUrl = value
  },
  SET_PARTNERS_NEXT_URL: (state, value) => {
    state.partners.next = value
  },
  SET_PARTNERS_PREV_URL: (state, value) => {
    state.partners.prev = value
  },
  SET_PARTNERS_LOADING: (state) => {
    state.partners.loading = true
  },
  SET_PARTNERS_LOADING_END: (state) => {
    state.partners.loading = false
  },
  SET_LAZYPARTNERS_LOADING: (state) => {
    state.partners.lazyLoading = true
  },
  SET_LAZYPARTNERS_LOADING_END: (state) => {
    state.partners.lazyLoading = false
  },
  SET_NEWPARTNERS_LOADING: (state) => {
    state.partners.newPartnersLoading = true
  },
  SET_NEWPARTNERS_LOADING_END: (state) => {
    state.partners.newPartnersLoading = false
  },
  SAVE_PARTNERS_ERROR: (state, error) => {
    state.partners.error = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
